import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlEn extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Rows Page';
}
